import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Taxes and Investment Income Calculator</h1>
        <iframe src="https://financialcalculators.net/librocu/investment-income/" title="Taxes and Investment Income Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
